import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'authentication',
  initialState: { loggedIn: false, user: '' },
  reducers: {
    loginSuccess(state, action) {
      state.loggedIn = true;
      state.user = action.payload;
    },
    loginFailure(state) {
      state.loggedIn = false;
      state.user = '';
    },
    logout(state) {
      state.loggedIn = false;
      state.user = '';
    },
  },
});

export const { loginSuccess, loginFailure, logout } = authSlice.actions;
export default authSlice.reducer;
